<template>
  <div class="info">
    <el-form :model="form" ref="infoForm" label-width="120px" class="info-form">
      <el-form-item> </el-form-item>
      <el-form-item label="用户头像">
        <headerPicture
          @getUrl="getImage($event)"
          :qrCodeUrl="form.avatarUrl"
        ></headerPicture>
      </el-form-item>
      <el-form-item label="用户ID">
        {{ form.id }}
      </el-form-item>
      <el-form-item label="用户昵称" prop="name">
        <el-input
          v-model="form.username"
          style="width: 30%"
          @change="updateName"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="name">
        {{ form.phone }}
      </el-form-item>
      <el-form-item label=" OPENID" prop="name">
        {{ form.openId }}
      </el-form-item>
      <!-- <el-form-item label="用户等级" prop="name">
        {{ form.vipLevelName }}
      </el-form-item> -->
      <el-form-item label="用户推荐人ID" prop="name">
        {{ form.referrerUserId || "--" }}
      </el-form-item>
      <el-form-item label=" 可提现佣金" prop="name">
        {{ form.commission }}
      </el-form-item>
      <el-form-item label="加入时间" prop="name">
        {{ form.joinTime }}
      </el-form-item>
      <el-form-item label="最近访问时间" prop="name">
        {{ form.lastActiveTime }}
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import headerPicture from '@/components/upload/headerPicture.vue'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  components: {
    headerPicture
  },
  data () {
    return {
      name: 'cdd',
      form: {}
    }
  },
  created () {
    console.log(this.id)
    this.getInfo()
  },
  watch: {
    id (val, vall) {
      this.id = val
    },
  },
  methods: {
    getInfo () {
      let params = {
        id: this.id
      }
      this.$api.getBaseInfo(params).then(res => {
        this.form = res.data
        if (this.form.avatarUrl == '') {
          this.form.avatarUrl = 'https://fenxiao.muruji.com/internalSystem/71f27eab-8ee0-418f-87ca-06f040c5c876'
        }
      })
    },
    updateName () {
      let data = {
        id: this.form.id,
        avatarUrl: this.form.avatarUrl,
        username: this.form.username
      }
      this.$api.updateUserInfo(data).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
        }
      })
    },
    getImage (val) {
      let data = {
        id: this.form.id,
        avatarUrl: val,
        username: this.form.username
      }
      this.$api.updateUserInfo(data).then(res => {
        if (res.code == 0) {
          // this.$message({
          //   type: 'success',
          //   message: '修改成功'
          // })
        }
      })

    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

